module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../~/entities/maps/xml.json
// module id = 20
// module chunks = 0